import { backendClient } from "./clients";

export function getCompanyPartners(company, external = false) {
  return backendClient
    .request({
      url: "/ListCompanyPartner",
      method: "post",
      data: {
        company,
        external,
      },
    })
    .then((res) => res.data)
    .catch((err) => {
      throw new Error("nu exista  parteneri ");
    });
}

export function updateCompanyPartner(company, partner) {
  return backendClient
    .request({
      url: "/UpdateCompanyPartner",
      method: "post",
      data: {
        company,
        partner,
      },
    })
    .then((res) => res.data)
    .catch((err) => err);
}

export function createCompanyPartner(company, partner) {
  return backendClient
    .request({
      url: "/AddCompanyPartner",
      method: "post",
      data: {
        company,
        partner,
      },
    })
    .then((res) => res.data)
    .catch((err) => {
      // console.log("sadasdsadasdasda",err)
      throw err;
    });
}

// .catch((err) => {
//   throw new Error(err.response.data.message);
// });

export function removeCompanyPartner(company, partnerId) {
  return backendClient
    .request({
      url: "/RemoveCompanyPartner",
      method: "post",
      data: {
        company,
        partnerId,
      },
    })
    .then((res) => res.data)
    .catch((err) => err);
}

export function getCompanyProducts(company) {
  return backendClient
    .request({
      url: "/ListCompanyProduct",
      method: "post",
      data: {
        company,
      },
    })
    .then((res) => res.data)
    .catch((err) => err);
}
export function createCompanySerial(company, serial) {
  return new Promise((resolve, reject) => {
    backendClient
      .request({
        url: "/AddCompanySerial",
        method: "post",
        data: {
          company,
          serial,
        },
      })
      .then((res) => resolve(res.data))
      .catch((err) => reject(err?.response?.data?.message?.code));
  });
}

export function updateCompanySerial(companyID, serialDetails) {
  return backendClient
    .request({
      url: "/UpdateCompanySerial",
      method: "post",
      data: {
        companyID,
        serialDetails,
      },
    })
    .then((res) => res.data)
    .catch((err) => err);
}

export function removeCompanySerial(company, serialId) {
  return backendClient
    .request({
      url: "/RemoveCompanySerial",
      method: "post",
      data: {
        company,
        serialId,
      },
    })
    .then((res) => res.data)
    .catch((err) => err);
}

export function getCompanySerials(company) {
  return backendClient
    .request({
      url: "/ListCompanySerial",
      method: "post",
      data: {
        company,
      },
    })
    .then((res) => res.data)
    .catch((err) => err);
}

export function createCompanyVATRates(company, vatRates) {
  return new Promise((resolve, reject) => {
    backendClient
      .request({
        url: "/AddCompanyVatRates",
        method: "post",
        data: {
          company,
          vatRates,
        },
      })
      .then((res) => resolve(res.data))
      .catch((err) => reject(err?.response?.data?.message?.code));
  });
}

export function getCompanyVatRates(company) {
  return backendClient
    .request({
      url: "/ListCompanyVatRates",
      method: "post",
      data: {
        company,
      },
    })
    .then((res) => res.data)
    .catch((err) => err);
}

export function removeCompanyVATRates(company, vatRates) {
  return backendClient
    .request({
      url: "/removeCompanyVATRates",
      method: "post",
      data: {
        company,
        vatRates: vatRates,
      },
    })
    .then((res) => res.data)
    .catch((err) => err);
}

export function createCompanyPaymentMethods(company, methods) {
  return new Promise((resolve, reject) => {
    backendClient
      .request({
        url: "/AddCompanyPaymentMethods",
        method: "post",
        data: {
          company,
          methods,
        },
      })
      .then((res) => resolve(res.data))
      .catch((err) => reject(err?.response?.data?.message?.code));
  });
}

export function getCompanyPaymentMethods(company) {
  return backendClient
    .request({
      url: "/ListCompanyPaymentMethods",
      method: "post",
      data: {
        company,
      },
    })
    .then((res) => res.data)
    .catch((err) => err);
}

export function removeCompanyPaymentMethods(company, method) {
  return backendClient
    .request({
      url: "/RemoveCompanyPaymentMethods",
      method: "post",
      data: {
        company,
        method: method,
      },
    })
    .then((res) => res.data)
    .catch((err) => err);
}

export function updateCompanyPaymentMethods(company, method) {
  return backendClient
    .request({
      url: "/UpdateCompanyPaymentMethod",
      method: "post",
      data: {
        company,
        method,
      },
    })
    .then((res) => res.data)
    .catch((err) => err);
}

export function updateCompanyProduct(company, id, product) {
  return backendClient
    .request({
      url: "/UpdateCompanyProduct",
      method: "post",
      data: {
        company,
        id,
        product,
      },
    })
    .then((res) => res.data)
    .catch((err) => err);
}

export function createCompanyProduct(company, product) {
  return backendClient
    .request({
      url: "/AddCompanyProduct",
      method: "post",
      data: {
        company,
        product,
      },
    })
    .then((res) => res.data)
    .catch((err) => {
      throw err;
    });
}

export function removeCompanyProduct(company, productId) {
  return backendClient
    .request({
      url: "/RemoveCompanyProduct",
      method: "post",
      data: {
        company,
        productId,
      },
    })
    .then((res) => res.data)
    .catch((err) => err);
}

export function validateCompanyProduct(company, product, strict) {
  return backendClient
    .request({
      url: "/AvailableProduct",
      method: "post",
      data: {
        company,
        product,
        strict,
      },
    })
    .then((res) => res.data);
}

export function sendBugsReport(data, log) {
  return backendClient
    .request({
      url: "/BugsReport",
      method: "post",
      data: {
        data,
        log,
      },
    })
    .then((res) => res.data)
    .catch((err) => err);
}
export function createDraft(company, user, draft, type = undefined) {
  return backendClient
    .request({
      url: "/SaveDraft",
      method: "post",
      data: {
        company,
        user,
        draft,
        type,
      },
    })
    .then((res) => res.data)
    .catch((err) => err);
}

export function updateDraft(company, draftId, user, draft, type = undefined, sendInfo) {
  return backendClient
    .request({
      url: "/UpdateDraft",
      method: "post",
      data: {
        company,
        draftId,
        user,
        draft,
        type,
        sendInfo,
      },
    })
    .then((res) => res.data)
    .catch((err) => err);
}

export function getCompanyDrafts(company) {
  return backendClient
    .request({
      url: "/ListSavedDrafts",
      method: "post",
      data: {
        company,
      },
    })
    .then((res) => res.data)
    .catch((err) => err);
}

export function processInvoices(companyID, dateRange) {
  return backendClient
    .request({
      url: "/RTPProcessInvoicesManual",
      method: "post",
      data: {
        companyID,
        dateRange
      },
    })
    .then((res) => res.data)
    .catch((err) => {
      throw err;
    });
}

export function processInvoicesExtra(companyID, dateRange) {
  return backendClient
    .request({
      url: "/RTPProcessInvoicesExtraSellers",
      method: "post",
      data: {
        companyID,
        dateRange
      },
    })
    .then((res) => res.data)
    .catch((err) => {
      throw err;
    });
}

export function assignAliasToMasterAPI(companyId, masterCode, aliasCode) {
  return backendClient
    .request({
      url: "/RTPAddProductAlias",
      method: "post",
      data: {
        companyId,
        masterCode,
        aliasCode
      },
    })
    .then((res) => res.data)
    .catch((err) => {
      throw err;
    });
};

export function generateDictionary(companyId, reportPeriod) {
  return backendClient
    .request({
      url: "/RTPGenerateDictionaryFromStock",
      method: "post",
      data: {
        companyId,
        reportPeriod
      },
    })
    .then((res) => res.data)
    .catch((err) => {
      throw err;
    });
};

export function getAutoPartsData(companyID, dateRange, saveBlob = false, ignoreUnresolved = false) {
  return backendClient
    .request({
      url: "/RTPAuto",
      method: "post",
      data: {
        companyID,
        dateRange,
        saveBlob,
        ignoreUnresolved
      },
    })
    .then((res) => res.data)
    .catch((err) => {
      throw err;
    });
}

export function SaveManualTransfers(companyID, transfers, currentPeriod) {
  return backendClient
    .request({
      url: "/RTPResolvePendingStockMatch",
      method: "post",
      data: {
        companyID,
        transfers,
        currentPeriod
      },
    })
    .then((res) => res.data)
    .catch((err) => {
      throw err;
    });
}

export async function getArchivedRTPBlob(period) {
  try {
    const res = await backendClient.request({
      url: "/RTPFetchBlob",
      method: "post",
      data: { period },
      responseType: "blob",
    });

    const blob = res.data;
    const decompressionStream = new DecompressionStream("gzip");
    const decompressedStream = blob.stream().pipeThrough(decompressionStream);
    const decompressedText = await new Response(decompressedStream).text();
    const jsonData = JSON.parse(decompressedText);

    return { success: true, data: jsonData };

  } catch (err) {
    console.error("Eroare la descărcarea sau dezarhivarea raportului:", err);

    return {
      success: false,
      message: err?.response?.data?.message || "Eroare la procesarea arhivei."
    };
  }
}

export async function getArchivedRTPTotalsBlob(period) {
  try {
    const res = await backendClient.request({
      url: "/RTPFetchTotalsBlob",
      method: "post",
      data: { period },
      responseType: "blob",
    });

    const blob = res.data;
    const decompressionStream = new DecompressionStream("gzip");
    const decompressedStream = blob.stream().pipeThrough(decompressionStream);
    const decompressedText = await new Response(decompressedStream).text();
    const jsonData = JSON.parse(decompressedText);

    return { success: true, data: jsonData };

  } catch (err) {
    console.error("Eroare la descărcarea sau dezarhivarea raportului:", err);
    return {
      success: false,
      message: err?.response?.data?.message || "Eroare la procesarea arhivei."
    };
  }
}

export async function getAvailableRTPBlobs() {
  try {
    const res = await backendClient.request({
      url: "/RTPAvailableTotalBlobs",
      method: "get",
    });

    return res.data;
  } catch (err) {
    console.error("Eroare la preluarea perioadelor disponibile:", err);
    return { success: false, data: [] };
  }
}

export function getAvailableRoutes() {
  return backendClient
    .request({
      url: "/RTPGetRoutes",
      method: "post",
      data: {}
    })
    .then((res) => res.data)
    .catch((err) => err);
}

export function saveRoute(routeName, routeCode, cod_depozit, id) {
  return backendClient
    .request({
      url: "/RTPAddRoute",
      method: "post",
      data: {
        routeName,
        routeCode,
        cod_depozit,
        id,
        isEdit: Boolean(id)
      },
    })
    .then((res) => res.data)
    .catch((err) => err);
}

export function updateRoute(id, routeName, routeCode, cod_depozit) {
  return saveRoute(routeName, routeCode, cod_depozit, id);
}

export function getRoutes() {
  return backendClient
    .request({
      url: "/RTPGetRoutes",
      method: "post",
      data: {},
    })
    .then((res) => res.data)
    .catch((err) => err);
}


export function deleteRoute(id) {
  return backendClient
    .request({
      url: "/RTPDeleteRoute",
      method: "post",
      data: {
        id
      },
    })
    .then((res) => res.data)
    .catch((err) => err);
}


export function SaveStock(excels) {
  return backendClient
    .request({
      url: "/RTPSaveStock",
      method: "post",
      data: {
        excels: excels
      },
    })
    .then((res) => res.data);
}

export function SaveExcelBonuri(excelData) {
  return backendClient
    .request({
      url: "/RTPSaveBonuri",
      method: "post",
      data: {
        excels: excelData
      },
    })
    .then((res) => res.data)
    .catch((err) => err);
}

export function TransformOEProducts(reportPeriod) {
  return backendClient
    .request({
      url: "/RTPTransformOECodes",
      method: "post",
      data: {
        reportPeriod,
      },
    })
    .then((res) => res.data)
    .catch((err) => {
      throw err;
    });
}

export function exportManualStockDecisions(companyID, startDate, endDate) {
  return backendClient
    .request({
      url: "/RTPExportManualStockDecisions",
      method: "post",
      data: {
        companyID,
        startDate,
        endDate,
      },
    })
    .then((res) => res.data)
    .catch((err) => {
      throw err;
    });
}

export function processReceiptsToLedger(companyID, excels, useCsvInvoicesFallback = false) {
  return backendClient
    .request({
      url: "/RTPProcessReceiptsLedger",
      method: "post",
      data: {
        companyID,
        excels,
        useCsvInvoicesFallback
      },
    })
    .then((res) => res.data)
    .catch((err) => {
      throw err;
    });
}

export function getProductLedgerCard(routeCode, epsClient, productCode, routeName) {
  return backendClient
    .request({
      url: "/RTPGetProductLedgerCard",
      method: "post",
      data: {
        routeCode,
        epsClient,
        productCode,
        routeName
      },
    })
    .then((res) => res.data)
    .catch((err) => {
      throw err;
    });
}

export function SaveExcelFacturi(excelData) {
  return backendClient
    .request({
      url: "/RTPSaveFacturi",
      method: "post",
      data: {
        excels: excelData
      },
    })
    .then((res) => res.data)
    .catch((err) => err);
}

export function GetBonuriMonths() {
  return backendClient
    .request({
      url: "/RTPGetReportPeriodsBonuri",
      method: "post",
    })
    .then((res) => res.data)
    .catch((err) => err);
}

export function GetFacturiMonths() {
  return backendClient
    .request({
      url: "/RTPGetReportPeriodsFacturi",
      method: "post",
    })
    .then((res) => res.data)
    .catch((err) => err);
}

export function GetStockMonths() {
  return backendClient
    .request({
      url: "/RTPGetReportPeriodsStocInitial",
      method: "post",
    })
    .then((res) => res.data)
    .catch((err) => err);
}

export function GenerateOpeningStock(companyID, reportPeriod, previewOnly = false) {
  return backendClient
    .request({
      url: "/RTPGenerateInitialStock",
      method: "post",
      data: {
        companyID,
        reportPeriod,
        previewOnly
      },
    })
    .then((res) => res.data)
    .catch((err) => err);
}

export function saveExpense(ExpenseData) {
  return backendClient
    .request({
      url: "/RTPSaveExpense",
      method: "post",
      data: { ExpenseData },
    })
    .then((res) => res.data)
    .catch((err) => err);
}
export function updateExpense(ExpenseData) {
  return backendClient
    .request({
      url: "/RTPUpdateExpense",
      method: "post",
      data: { ExpenseData },
    })
    .then((res) => res.data)
    .catch((err) => err);
}
export function deleteExpense(id) {
  return backendClient
    .request({
      url: "/RTPDeleteExpense",
      method: "post",
      data: { id },
    })
    .then((res) => res.data)
    .catch((err) => err);
}

export function getExpenses(data) {
  return backendClient
    .request({
      url: "/RTPGetExpenses",
      method: "post",
      data: data,
    })
    .then((res) => res.data)
    .catch((err) => err);
}

export function deleteFromLedger(reportPeriod) {
  return backendClient
    .request({
      url: "/RTPDeleteFromLedger",
      method: "post",
      data: { reportPeriod },
    })
    .then((res) => res.data)
    .catch((err) => err);
}

export function deleteFromLedgerIN(reportPeriod) {
  return backendClient
    .request({
      url: "/RTPDeleteFromLedgerIN",
      method: "post",
      data: { reportPeriod },
    })
    .then((res) => res.data)
    .catch((err) => err);
}

export function deletePendingStockMatches(reportPeriod, companyId = "7bca491b-99a2-4ed5-9ae1-ab9394e84dfa") {
  return backendClient
    .request({
      url: "/RTPDeletePendingStockMatches",
      method: "post",
      data: { reportPeriod, companyId },
    })
    .then((res) => res.data)
    .catch((err) => err);
}

export function deleteFromStock(reportPeriod) {
  return backendClient
    .request({
      url: "/RTPDeleteFromStock",
      method: "post",
      data: { reportPeriod },
    })
    .then((res) => res.data)
    .catch((err) => err);
}

export function getRTPInvoicesCount(reportPeriods) {
  return backendClient
    .request({
      url: "/RTPCountInvoices",
      method: "post",
      data: { reportPeriods },
    })
    .then((res) => res.data)
    .catch((err) => err);
}

export function saveClientLimit(data) {
  return backendClient
    .request({
      url: "/RTPSaveClientLimit",
      method: "post",
      data: {
        routeCode: data.routeCode,
        clientCode: data.clientCode,
        limit: data.limit
      },
    })
    .then((res) => res.data)
    .catch((err) => err);
}

export function getClientLimits() {
  return backendClient
    .request({
      url: "/RTPGetClientLimit",
      method: "post",
    })
    .then((res) => res.data)
    .catch((err) => { throw err; });
}

export function getExtraSellers() {
  return backendClient
    .request({
      url: "/RTPGetSellers",
      method: "post",
    })
    .then((res) => res.data)
    .catch((err) => { throw err; });
}

export function saveExtraSeller(sellerCif, sellerName) {
  return backendClient
    .request({
      url: "/RTPSaveSeller",
      method: "post",
      data: {
        sellerCif,
        sellerName
      },
    })
    .then((res) => res.data)
    .catch((err) => err);
}

export function deleteExtraSeller(sellerCif) {
  return backendClient
    .request({
      url: "/RTPDeleteSeller",
      method: "post",
      data: {
        sellerCif
      },
    })
    .then((res) => res.data)
    .catch((err) => err);
}

export function processExtraSeller(cif) {
  return backendClient
    .request({
      url: "/RTPProcessInvoicesExtraSellers",
      method: "post",
      data: {
        cif
      },
    })
    .then((res) => res.data)
    .catch((err) => err);
}

export function saveTransaction(data) {
  return backendClient
    .request({
      url: "/RTPSaveTransaction",
      method: "post",
      data: data,
    })
    .then((res) => res.data)
    .catch((err) => err);
}

export function removeDraft(company, id) {
  return backendClient
    .request({
      url: "/RemoveCompanyDraft",
      method: "post",
      data: {
        company,
        id,
      },
    })
    .then((res) => res.data)
    .catch((err) => err);
}

export function createExtern(company, user, draft) {
  return backendClient
    .request({
      url: "/SaveDraftExtern",
      method: "post",
      data: {
        company,
        user,
        draft,
      },
    })
    .then((res) => res.data)
    .catch((err) => err);
}

export function getCompanyExterns(company) {
  return backendClient
    .request({
      url: "/ListSavedExternDrafts",
      method: "post",
      data: {
        company,
      },
    })
    .then((res) => res.data)
    .catch((err) => err);
}

export function createRecurrentInvoice(company, user, recurentData) {
  return backendClient
    .request({
      url: "/CreateRecurentInvoice",
      method: "post",
      data: {
        company,
        user,
        recurentData,
      },
    })
    .then((res) => res.data)
    .catch((err) => err);
}

export function updateRecurrentInvoice(
  company,
  recurentID,
  updateData,
  lastSend,
  lastIdIncarcareAnaf,
  lastValue,
  lastSerialNumber
) {
  return backendClient
    .request({
      url: "/UpdateRecurentInvoice",
      method: "post",
      data: {
        company,
        recurentID,
        updateData,
        lastSend,
        lastIdIncarcareAnaf,
        lastValue,
        lastSerialNumber,
      },
    })
    .then((res) => res.data)
    .catch((err) => err);
}

export function getCompanyRecurrents(company) {
  return backendClient
    .request({
      url: "/ListRecurentInvoices",
      method: "post",
      data: {
        company,
      },
    })
    .then((res) => res.data)
    .catch((err) => err);
}

//deoarece este in drafturi folosim tot functia de sters drafturi
export function removeRecurrent(company, id) {
  return backendClient
    .request({
      url: "/RemoveCompanyContracts",
      method: "post",
      data: {
        company,
        id,
      },
    })
    .then((res) => res.data)
    .catch((err) => err);
}

export function addCompanyBankAccount(company, bankAccount) {
  return backendClient
    .request({
      url: "/CreateCompanyBankAccount",
      method: "post",
      data: {
        company,
        bankAccount,
      },
    })
    .then((res) => res.data)
    .catch((err) => {
      throw err;
    });
}

export function updateCompanyBankAccount(companyDto, accountDetails) {
  return backendClient
    .request({
      url: "/UpdateCompanyBankAccount",
      method: "post",
      data: {
        company: companyDto,
        bankAccount: accountDetails,
      },
    })
    .then((res) => res.data)
    .catch((err) => err);
}

export function getCompanyBankAccount(company) {
  return backendClient
    .request({
      url: "/ListBankAccount",
      method: "post",
      data: {
        company,
      },
    })
    .then((res) => res.data)
    .catch((err) => {
      throw new Error("nu exista");
    });
}

export function removeCompanyBankAccount(company, banckId) {
  return backendClient
    .request({
      url: "/RemoveBankAccount",
      method: "post",
      data: {
        company,
        banckId,
      },
    })
    .then((res) => res.data)
    .catch((err) => err);
}

export function getCountAllDataClient(company, userId) {
  return backendClient
    .request({
      url: "/CountAllDataClient",
      method: "post",
      data: {
        company,
        userId,
      },
    })
    .then((res) => res.data)
    .catch((err) => err);
}

export function getCountClientSent(company, userId, refresh = false) {
  return backendClient
    .request({
      url: "/CountClientSent",
      method: "post",
      data: {
        company,
        userId,
        refresh,
      },
    })
    .then((res) => res?.data)
    .catch((err) => err);
}

export function getCountClientReceived(company, userId, refresh = false) {
  return backendClient
    .request({
      url: "/CountClientReceived",
      method: "post",
      data: {
        company,
        userId,
        refresh,
      },
    })
    .then((res) => res?.data)
    .catch((err) => err);
}

export function getAllSubscriptions() {
  return backendClient
    .request({
      url: "GetAllSubscriptionsForUser",
      method: "post",
    })
    .then((res) => res.data)
    .catch((err) => err);
}

export function createCompanySerialDecision(company, data) {
  return backendClient
    .request({
      url: "AddCompanySerialDecision",
      method: "post",
      data: {
        company,
        data,
      },
    })
    .then((res) => res.data)
    .catch((err) => {
      // console.log("not backend", err)
    });
}

export function getAllSerialDecision(company) {
  return backendClient
    .request({
      url: "GetAllSerialDecision",
      method: "post",
      data: {
        company,
      },
    })
    .then((res) => res.data)
    .catch((err) => {
      // console.log(err)
    })
    .finally(() => {
      // console.log("este in finally");
    });
}

export function DownloadAllDataClientDelete(userId) {
  return backendClient
    .request({
      url: "/SaveAllDataClientDeleteAcc",
      method: "post",
      data: {
        userId,
      },
    })
    .then((res) => res.data)
    .catch((err) => err);
}

export function CheckUserSubscriptionStatus() {
  return backendClient
    .request({
      url: "/CheckUserSubscriptionStatus",
      method: "post",
    })
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      throw err;
    });
}

export function createCompanyTransporter(company, transporter) {
  return backendClient
    .request({
      url: "/AddCompanyTransporter",
      method: "post",
      data: {
        company,
        transporter,
      },
    })
    .then((res) => res.data)
    .catch((err) => {
      throw err;
    });
}

export function getCompanyTransporters(company) {
  return backendClient
    .request({
      url: "/ListCompanyTransporter",
      method: "post",
      data: {
        company,
      },
    })
    .then((res) => res.data)
    .catch((err) => err);
}

export function removeCompanyTransporter(company, transporterId) {
  return backendClient
    .request({
      url: "/RemoveCompanyTransporter",
      method: "post",
      data: {
        company,
        transporterId,
      },
    })
    .then((res) => res.data)
    .catch((err) => err);
}

export function updateNotificationConfig(type, config) {
  return backendClient
    .request({
      url: "/UpdateNotificationConfig",
      method: "post",
      data: {
        type,
        config,
      },
    })
    .then((res) => res.data)
    .catch((err) => err);
}

export function removeNotificationConfig(type, config) {
  return backendClient
    .request({
      url: "/RemoveNotificationConfig",
      method: "post",
      data: {
        type,
        config,
      },
    })
    .then((res) => res.data)
    .catch((err) => err);
}

export function sendNotification(type, data, user) {
  return backendClient
    .request({
      url: "/SendNotificationToUser",
      method: "post",
      data: {
        type,
        data,
        user,
      },
    })
    .then((res) => res.data)
    .catch((err) => err);
}

export function getCompanySyncSummary(company, date = undefined) {
  return backendClient
    .request({
      url: "/GetCompanySyncStatus",
      method: "post",
      data: {
        company,
        date,
      },
    })
    .then((res) => res.data)
    .catch((err) => err);
}

export function saveCompanyInternalCodes(companyId, payload) {
  let data = { companyId };

  if (Array.isArray(payload)) {
    data.isImport = true;
    data.internalCodes = payload;
  } else {
    data.internalCode = payload;
  }

  return backendClient
    .request({
      url: "/AddCompanyInternCode",
      method: "post",
      data,
    })
    .then((res) => res.data)
    .catch((err) => {
      throw err?.response?.data?.message || err?.message;
    });
}

export function getCompanyInternalCodes(companyId) {
  if (!companyId) throw new Error("Missing companyId");

  return backendClient
    .request({
      url: `/GetCompanyInternCodes`,
      method: "post",
      data: { companyId },
    })
    .then((res) => res.data)
    .catch((err) => {
      throw err?.response?.data?.message || err?.message;
    });
}

// services/invoicesAPI.js (sau un fișier relevant)
export function saveInternalCodes(
  invoiceId,
  companyId,
  internCodes,
  internCodesCompletedFull
) {
  return backendClient
    .request({
      url: `/SaveInternalCodes`,
      method: "post",
      data: {
        invoiceId,
        companyId,
        internCodes,
        internCodesCompletedFull,
      },
    })
    .then((res) => res.data)
    .catch((err) => {
      throw err?.response?.data?.message || err?.message;
    });
}
